export enum PaymentType {
  Refund = 'refund',
  Request = 'request',
  Received = 'received',
}
